import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import { TRANSLATIONS } from './translations';

/**
 * The app's six languages, in the app's order (`APP_LANGUAGES` in @imko/constants). `name`
 * is each language's own name — shown as is in the picker, never translated.
 */
export const LOCALES = [
  { id: 'de', name: 'Deutsch' },
  { id: 'en', name: 'English' },
  { id: 'es', name: 'Español' },
  { id: 'it', name: 'Italiano' },
  { id: 'ja', name: '日本語' },
  { id: 'ko', name: '한국어' },
] as const;

export type TLocale = (typeof LOCALES)[number]['id'];

export const DEFAULT_LOCALE: TLocale = 'en';

/** The chosen language, remembered per browser. Not httpOnly: nothing secret in it. */
export const LOCALE_COOKIE = 'imko-locale';

export const isLocale = (value: unknown): value is TLocale => LOCALES.some(locale => locale.id === value);

export const RESOURCES = {
  de: { translation: de },
  en: { translation: en },
  es: { translation: es },
  it: { translation: it },
  ja: { translation: ja },
  ko: { translation: ko },
} satisfies Record<TLocale, { translation: object }>;

type TLeaves<T> = T extends string ? T : { [K in keyof T]: TLeaves<T[K]> }[keyof T];

/** Every key in TRANSLATIONS, so `t('organizations.titel')` is a type error, not a raw key on screen. */
export type TTranslationKey = TLeaves<typeof TRANSLATIONS>;

export { TRANSLATIONS };
